import axios from 'axios';
import moment from 'moment';

class MitSpacesService {
  constructor() {
    this.spaceBuildingId = 1;//default, not ideal, but for now...
    this.SPACE_TYPES = {
      building:{
            name: 'Building',
            id: 'building'
      },
      floor:{
            name: 'Floor',
            id: 'floor'
      },
      space:{
            name: 'Space',
            id: 'space'
      },
      object: {
            name: 'Object',
            id: 'object'
      }
    };
    this.SPACE_TYPES_DEFAULT = this.SPACE_TYPES.space;
    this.SPACE_TYPES_ARRAY = [];//array version, helper for things like selection boxes that need an array.

    for(let k in this.SPACE_TYPES){
      this.SPACE_TYPES_ARRAY.push(this.SPACE_TYPES[k]);
    }
  }

  getCurrentSpaceList(){
    return new Promise ((resolve, reject) => {

      axios.get('/api/v1/spaces/current')
        .then((response) => {
            return resolve(response.data.spaces);
        })
        .catch((error) => {
          if(error.response)
            return reject(error.response.data);

          return reject(error);
        });

    });
  }
  // getNextAvailableLevel(spaces){
  //   let level = null;
  //   for(let x = 0; x < spaces.length; x++){
  //     if(spaces[x].data.level && (level === null || level < spaces[x].data.level)){
  //       level = spaces[x].data.level;
  //     }
  //   }
  //   return level;
  // }

  // getSpaceDefault() {
  //   return {
  //     id:null,
  //     name:'',
  //     type:this.SPACE_TYPES_DEFAULT,
  //     data:{
  //       notes:''
  //     }
  //   }
  // }

  // adaptTreeToUIModel(tree){
  //   tree = this.adaptToUIModel(tree);
  //
  //   if(tree.children && tree.children.length > 0){
  //     for(let x = 0; x < tree.children.length; x++){
  //       this.adaptTreeToUIModel(tree.children[x]);
  //     }
  //   }
  // }
  // adaptTreeToAPIModel(tree){
  //   tree = this.adaptToAPIModel(tree);
  //
  //   if(tree.children && tree.children.length > 0){
  //     for(let x = 0; x < tree.children.length; x++){
  //       this.adaptTreeToAPIModel(tree.children[x]);
  //     }
  //   }
  // }
  adaptToUIModel(space){
    space.spaceTypeUI = this.SPACE_TYPES[space.spaceType].name;//replace with UI type.
    // space.dates_local = {
    //   lastEditedDate: moment(space.lastEditedDate).local().fromNow()
    // };
    return space;
  }
  // adaptToAPIModel(space){
  //   space.type = space.type.id;
  //   delete space.dates_local;
  //
  //   return space;
  // }

  getData(method, path, data) {
    return new Promise ((resolve, reject) => {
      let reqModel = {
        data:data, //this will get forwarded to the spaces api
        req:{
          method:method, //this will get forwarded to the spaces api
          path:path //this will get forwarded to the spaces api
        }
      }
      axios.post('/api/v1/spaces/', reqModel)
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error);
        });

    });
  }
  // getBuildings() {
  //   return new Promise ((resolve, reject) => {
  //
  //     this.getData('GET', '/v1/user/spaces/buildings')
  //       .then((buildings) => {
  //           return resolve(buildings);
  //       })
  //       .catch((error) => {
  //         console.log('ERROR:', error);
  //         return reject(error.response.data);
  //       });
  //
  //   });
  // }
  // getBuildingFloors() {
  //   return new Promise ((resolve, reject) => {
  //     this.getData('GET', '/v1/user/spaces/buildings/'+this.spaceBuildingId+'?spaceTypes=floor,building')
  //       .then((buildings) => {
  //           return resolve(buildings);
  //       })
  //       .catch((error) => {
  //         console.log('ERROR:', error);
  //         return reject(error.response.data);
  //       });
  //
  //   });
  // }

  getBuildingSpacesList(filterBySpaceType) {
    return new Promise ((resolve, reject) => {
      let url = '/v2/user/spaces';

      if(filterBySpaceType) url += '?types='+filterBySpaceType;

      this.getData('GET', url)
        .then((data) => {
            data.spacesNameDictionary = {};//Add a dictionary for fast lookup by name

            for(let x = 0; x < data.spaces.length; x++){
              data.spaces[x] = this.adaptToUIModel(data.spaces[x]);
              data.spacesNameDictionary[data.spaces[x].mitId] = data.spaces[x];
            }
            return resolve(data);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response.data);
        });

    });
  }
  // getBuildingSpacesTree() {
  //   return new Promise ((resolve, reject) => {
  //
  //     this.getData('GET', '/v1/user/spaces/relationships/buildings/'+this.spaceBuildingId)
  //       .then((data) => {
  //           this.adaptTreeToUIModel(data.building);
  //           return resolve(data);
  //       })
  //       .catch((error) => {
  //         console.log('ERROR:', error);
  //         return reject(error.response.data);
  //       });
  //
  //   });
  // }

  // upsertSpaces(spacesTree) {
  //   return new Promise ((resolve, reject) => {
  //     this.adaptTreeToAPIModel(spacesTree);
  //
  //     this.getData('POST', '/admin/spaces', spacesTree)
  //       .then((data) => {
  //           return resolve(data);
  //       })
  //       .catch((error) => {
  //         console.log('ERROR:', error);
  //         return reject(error.response.data);
  //       });
  //
  //   });
  // }

  // upsertSpace(space) {
  //   return new Promise ((resolve, reject) => {
  //     space = this.adaptToAPIModel(space);
  //
  //     this.getData('POST', '/admin/spaces/space', space)
  //       .then((data) => {
  //           space = this.adaptToUIModel(data);
  //           return resolve(data);
  //       })
  //       .catch((error) => {
  //         console.log('ERROR:', error);
  //         return reject(error.response.data);
  //       });
  //
  //   });
  // }

  // deleteSpace(id) {
  //   return new Promise ((resolve, reject) => {
  //     this.getData('DELETE', '/admin/spaces/'+ id)
  //       .then((data) => {
  //           return resolve(true);
  //       })
  //       .catch((error) => {
  //         console.log('ERROR:', error);
  //         return reject(error.response.data);
  //       });
  //
  //   });
  // }



}

export default new MitSpacesService();
